import { getRoundedPercentChange, isAtOrBeyondThreshold } from '../../helpers'
import { FALL_RISK_LEVELS } from 'ui/hooks/consts'

export const getMobilityIconVariant = ({ trend, invertColors = false }) => {
  if (isAtOrBeyondThreshold(trend)) {
    if (trend > 0) {
      return invertColors ? 'worse' : 'better'
    } else if (trend < 0) {
      return invertColors ? 'better' : 'worse'
    }
  }
  return null
}

export const formatMobilityDiff = (t, metric, prevMetric) => {
  const diff = metric?.averageValue - prevMetric?.averageValue
  const amount = `${Math.abs(diff.toFixed(2))}${metric?.averageUnit}`
  if (diff < 0) {
    return t('report.trend.diffLess', { amount })
  } else if (diff > 0) {
    return t('report.trend.diffMore', { amount })
  }
  return amount
}

export const getFallRiskIconVariant = (currentLevel, prevLevel) => {
  if (!currentLevel || !prevLevel) return null
  const currentSeverity = FALL_RISK_LEVELS[currentLevel]
  const prevSeverity = FALL_RISK_LEVELS[prevLevel]
  if (currentSeverity > prevSeverity) return 'worse'
  if (currentSeverity < prevSeverity) return 'better'
  return null
}

export const getMobilityMetricProps = (
  currentData,
  prevData,
  label,
  invertColors,
  t,
) => {
  if (!currentData?.averageValue)
    return {
      label,
      value: '—',
      trend: 0,
      trendLabel: '',
    }

  const value = `${currentData?.averageValue}${currentData?.averageUnit}`
  const trend = getRoundedPercentChange(
    currentData?.averageValue,
    prevData?.averageValue,
  )
  const trendLabel = formatMobilityDiff(t, currentData, prevData)
  const noPrevData = !prevData?.averageValue
  const iconVariant = getMobilityIconVariant({ trend, invertColors })

  return {
    label,
    value,
    trend,
    trendLabel,
    noPrevData,
    iconVariant,
  }
}
